const materials: MaterialStat[] = [
  {
    id: 'c3d-albert',
    label: 'Albert',
    densityKgM3: 2135,
    waterPercent: 15.8,
    maxVerticalSpeedMmH: 3000,
    defaultPriceEurBigBag: 420,
  },
  {
    id: 'sika-733',
    label: 'Sika 733',
    densityKgM3: 2245,
    waterPercent: 13.5,
    maxVerticalSpeedMmH: 300,
    defaultPriceEurBigBag: 1000,
  },
  {
    id: 'sika-751',
    label: 'Sika 751',
    densityKgM3: 2142,
    waterPercent: 14.5,
    maxVerticalSpeedMmH: 900,
    defaultPriceEurBigBag: 1000,
  },
  {
    id: 'lafarge-tector',
    label: 'Lafarge Tector',
    densityKgM3: 2151,
    waterPercent: 15,
    maxVerticalSpeedMmH: 300,
    defaultPriceEurBigBag: 1000,
  },
  {
    id: 'parex-clavex-704',
    label: 'Parex Clavex 704',
    densityKgM3: 2299,
    waterPercent: 15,
    maxVerticalSpeedMmH: 300,
    defaultPriceEurBigBag: 1000,
  },
]

export default materials
